import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  AppFacade,
  AuthFacade,
  AutoUnsubscribe,
  Language,
  LoadingFacade,
  AuthRefreshSchedulerService,
} from '@intrack/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class AppComponent implements OnInit {
  subscriptions: Subscription[] = [];

  constructor(
    public authFacade: AuthFacade,
    public loadingFacade: LoadingFacade,
    private translateService: TranslateService,
    private appFacade: AppFacade,
    private authRefreshScheduler: AuthRefreshSchedulerService,
  ) {}

  ngOnInit(): void {
    this.authRefreshScheduler.start();

    this.subscriptions.push(
      this.appFacade.currentLanguage$
        .pipe(filter(Boolean))
        .subscribe((language: Language) => this.translateService.use(language.toLowerCase())),
      this.authFacade.defaultLanguage$
        .pipe(filter(Boolean))
        .subscribe((language: Language) => this.appFacade.changeLang(language)),
    );

    window.addEventListener('message', (event) => {
      // for testng purposes only
      // SECURITY
      if (event.origin !== 'https://shell-local.intrack-bosch.com') {
        return;
      }

      if (!event.data) {
        return;
      }

      if (event.data.type === 'INIT_LEGACY_AUTH') {
        // eslint-disable-next-line no-console
        console.log('INIT_LEGACY_AUTH received');

        this.authFacade.bootstrapFromSession();

        // optional: route
        if (event.data.targetRoute) {
          // eslint-disable-next-line no-console
          console.log('Target route:', event.data.targetRoute);
        }
      }
    });
  }
}
